export const APP_PROFILES = {
  DEFAULT: 'default',
  POS_FRONTLINE: 'pos_frontline',
};

export const ALL_APP_PROFILES = [APP_PROFILES.DEFAULT, APP_PROFILES.POS_FRONTLINE];

export const getCurrentAppProfile = () => {
  const raw = String(process.env.REACT_APP_APP_PROFILE || APP_PROFILES.DEFAULT)
    .trim()
    .toLowerCase();
  if (raw === APP_PROFILES.POS_FRONTLINE) {
    return APP_PROFILES.POS_FRONTLINE;
  }
  return APP_PROFILES.DEFAULT;
};

export const isProfileAllowed = (profiles, profile) => {
  const allowed = Array.isArray(profiles) && profiles.length > 0 ? profiles : ALL_APP_PROFILES;
  return allowed.includes(profile);
};
